// extracted by mini-css-extract-plugin
module.exports = {"title":"DrawerBase_title__Cid9l","drawer":"DrawerBase_drawer__eADQz","closeIcon":"DrawerBase_closeIcon__BmwR6"};